<template>
    <div id="co2-transport-widget-component">
        <WidgetWrapperComponent
            :class="is_widget_open ? 'widget-full-height' : ''"
            :title="$t('product_report.co2_transport_impact')"
            id-widget="product-report-co2"
            v-on:toggle="is_widget_open = $event"
        >
            <template v-slot:default>
                <p class="font-12 font-color-medium">
                    {{ $t('product_report.co2_transport_subtitle') }}
                    <b v-if="client_code">{{ client_code }}</b>
                </p>

                <v-row class="text-center">
                    <v-col cols="12" sm="4">
                        <p class="font-10 text-uppercase font-color-medium mb-0">{{ $t('product_report.total_weight') }}</p>
                        <p class="font-18 font-weight-bold mb-0">{{ number(transport.weight_kg) }} kg</p>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <p class="font-10 text-uppercase font-color-medium mb-0">{{ $t('product_report.distance') }}</p>
                        <p class="font-18 font-weight-bold success--text mb-0">{{ number(transport.distance_km) }} km</p>
                        <p class="font-10 font-color-medium mb-0">{{ $t('product_report.one_way') }}</p>
                    </v-col>
                    <v-col cols="12" sm="4">
                        <p class="font-10 text-uppercase font-color-medium mb-0">{{ $t('product_report.co2_generated') }}</p>
                        <p class="font-18 font-weight-bold success--text mb-0">{{ number(transport.co2_kg, 2) }} kg CO2</p>
                    </v-col>
                </v-row>

                <div v-if="transport.avoided_co2_kg" class="d-flex gap-2 mt-4 pa-3 report-note">
                    <v-icon color="success">mdi-leaf</v-icon>
                    <span class="font-12">
                        {{
                            $t('product_report.avoided_impact', {
                                co2: number(transport.avoided_co2_kg, 1),
                                water: number(totals.water_l),
                            })
                        }}
                    </span>
                </div>

                <div class="d-flex flex-wrap align-stretch gap-2 mt-4">
                    <div class="d-flex gap-2 pa-3 report-note font-10 flex-grow-1">
                        <v-icon color="success">mdi-leaf</v-icon>
                        <div>
                            <p class="line-height-12 mb-0">
                                {{
                                    $t('product_report.co_two_calc_intro', {
                                        weight: transport.bidon_weight_kg,
                                        distance: number(transport.distance_km),
                                    })
                                }}
                            </p>
                            <p class="line-height-12 mb-0">
                                {{
                                    $tc('product_report.co_two_calc_detail', totals.bidons_consumed, {
                                        weight: transport.bidon_weight_kg,
                                        distance: number(transport.distance_km),
                                        co2PerBidon: number(transport.co2_per_bidon_kg, 3),
                                        count: totals.bidons_consumed,
                                        totalWeight: number(transport.weight_kg),
                                        totalCo2: number(transport.co2_kg, 2),
                                    })
                                }}
                            </p>
                            <p class="font-color-medium line-height-12 mb-0">
                                {{
                                    $t('product_report.co2_calc_average', {
                                        factor: number(transport.factor_kg_per_tonne_km, 2),
                                    })
                                }}
                            </p>
                        </div>
                    </div>
                    <div class="d-flex align-center pa-3 report-reference font-10 font-color-medium">
                        {{
                            $t('product_report.co2_reference', {
                                distance: number(transport.distance_km),
                                co2PerBidon: number(transport.co2_per_bidon_kg, 3),
                            })
                        }}
                    </div>
                </div>
            </template>
        </WidgetWrapperComponent>
    </div>
</template>
<script>
import WidgetWrapperComponent from '@/components/global/wrapper/WidgetWrapperComponent.vue'
import number from '@/mixin/number'

export default {
    name: 'Co2TransportWidgetComponent',
    components: {
        WidgetWrapperComponent,
    },
    mixins: [number],
    props: {
        transport: {
            type: Object,
            required: true,
        },
        totals: {
            type: Object,
            required: true,
        },
        client_code: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            is_widget_open: true,
        }
    },
}
</script>
